const initialState = {
  loading: false,
  allSubject: [],
  selectedAcademic: null,
};

const subjectReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "LOADING_SUBJECT": {
      return {
        ...state,
        loading: actions.loading,
      };
    }
    case "GET_SUBJECT_DATA": {
      return {
        ...state,
        loading: actions.loading,
        allSubject: actions.data,
        selectedAcademic: actions.id,
      };
    }
    case "CLEAR_DATA": {
      return {
        ...state,
        allSubject: [],
        selectedAcademic: null,
      };
    }
    //   case "UPDATE_EVENT": {
    //     return { ...state, events: actions.data };
    //   }
    //   case "GET_EVENT_GROUPS": {
    //     return { ...state, eventGroup: actions.data };
    //   }
    //   case "SET_SELECTED_EVENT": {
    //     return { ...state, selectedEvent: actions.data };
    //   }
    //   case "CLEAR_EVENT": {
    //     return { ...state, selectedEvent: [] };
    //   }
    default:
      return state;
  }
};
export default subjectReducer;
